/**
 * Comparador personalizado para evitar re-renderizações desnecessárias
 * @param {Object} a - Primeiro objeto para comparação
 * @param {Object} b - Segundo objeto para comparação
 * @returns {boolean} - True se os objetos forem considerados iguais
 */
import { useMemo, useRef } from 'react';
import isEqual from 'lodash/isEqual';

export const shallowEqual = (a, b) => {
  if (a === b) return true;
  if (!a || !b) return false;

  // Comparação específica apenas para os dados que realmente importam
  return isEqual(a?.items, b?.items) && a?.loaded === b?.loaded;
};

/**
 * Hook personalizado para gerenciar os items e uids
 * @param {Array} propertyValue - Valor da propriedade que contém os itens
 * @returns {Object} - Objeto contendo items e uids processados
 */
export const useQueryItems = (propertyValue) => {
  const itemsRef = useRef(null);

  // Memoize items comparing actual content
  const items = useMemo(() => {
    if (
      itemsRef.current === null ||
      !isEqual(itemsRef.current, propertyValue || [])
    ) {
      itemsRef.current = propertyValue || [];
    }
    return itemsRef.current;
  }, [propertyValue]);

  const uids = useMemo(() => {
    return items.reduce((accumulator, item) => {
      const { source = [] } = item;
      if (source.length > 0) {
        accumulator.push(source[0]['UID']);
      }
      return accumulator;
    }, []);
  }, [items]);

  return { items, uids };
};
